import noop from 'lodash/noop';
import React, { Component } from 'react';
import styled from 'styled-components';
import Textbox from '@zocdoc-frontend-common/components-textbox';
import { red80 } from '@zocdoc-mezzanine/foundations-colors';

/**
 * @param {boolean} hasErrors
 * @param {function(): void} onBlur
 * @param {function(): void} onChange
 * @param {function(): void} onFocus
 * @param {Object} statusChecks
 * @param {boolean} showStatusChecks
 * @returns {JSX.Element}
 * @constructor
 */
export default class PasswordField extends Component {
    static defaultProps = {
        onChange: noop,
        onBlur: noop,
        onFocus: noop,
    };

    render() {
        const { onChange, onFocus, onBlur, hasErrors } = this.props;
        return (
            <React.Fragment>
                <StyledTextBox
                    autoComplete="new-password"
                    className="exclude-from-playback"
                    onChange={onChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    type="password"
                    data-test="create-password-textbox"
                    invalid={hasErrors}
                />
            </React.Fragment>
        );
    }
}

const StyledTextBox = styled(Textbox)`
    ${(p) => (p.invalid ? `border-color: ${red80}` : '')};
    z-index: 2;
`;
